<script>
  import Layout from '/components/Layout.svelte';
  import { inertia, router, page } from '@inertiajs/svelte';

  export let type = '';
  export let files = [];

  $: flash = $page.props.flash || {};

  let search = '';
  $: filtered = search
    ? files.filter(f => f.display.toLowerCase().includes(search.toLowerCase()))
    : files;

  const typeLabel = type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
</script>

<svelte:head>
  <title>{typeLabel} — Age of Trevor Webedit</title>
</svelte:head>

<Layout title={typeLabel}>
  {#if flash.notice}
    <div class="flash flash-notice">{flash.notice}</div>
  {/if}
  {#if flash.alert}
    <div class="flash flash-alert">{flash.alert}</div>
  {/if}

  <div class="toolbar">
    <input
      class="search-input"
      type="search"
      placeholder="Filter files…"
      bind:value={search}
    />
    <a use:inertia href="/editor/{type}/new" class="btn-new">+ New file</a>
  </div>

  <div class="file-count">{filtered.length} of {files.length} files</div>

  {#if filtered.length === 0}
    <p class="empty">No files found.</p>
  {:else}
    <ul class="file-list">
      {#each filtered as file}
        <li class="file-item">
          <a use:inertia href="/editor/{type}/{file.relative_path.replace(/\.yml$/, '')}" class="file-link">
            <span class="file-name">{file.display}</span>
            <span class="file-ext">.yml</span>
          </a>
        </li>
      {/each}
    </ul>
  {/if}
</Layout>

<style>
  .flash {
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
    font-weight: 500;
  }

  .flash-notice {
    background: #f0fdf4;
    border: 1px solid #86efac;
    color: #166534;
  }

  .flash-alert {
    background: #fef2f2;
    border: 1px solid #fca5a5;
    color: #dc2626;
  }

  .toolbar {
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-bottom: 1rem;
  }

  .search-input {
    flex: 1;
    padding: 0.5rem 0.875rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    font-size: 0.95rem;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .search-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }

  .btn-new {
    background: #1d4ed8;
    color: white;
    padding: 0.5rem 1.25rem;
    border-radius: 0.5rem;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.9rem;
    white-space: nowrap;
    transition: background 0.2s;
  }

  .btn-new:hover {
    background: #1e40af;
  }

  .file-count {
    font-size: 0.8rem;
    color: #94a3b8;
    margin-bottom: 0.75rem;
  }

  .empty {
    color: #94a3b8;
    font-style: italic;
  }

  .file-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .file-item {
    border-radius: 0.5rem;
    overflow: hidden;
  }

  .file-link {
    display: flex;
    align-items: baseline;
    gap: 0.25rem;
    padding: 0.6rem 0.875rem;
    text-decoration: none;
    color: #1e293b;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    transition: background 0.15s, border-color 0.15s;
    font-family: 'Fira Code', monospace;
    font-size: 0.875rem;
  }

  .file-link:hover {
    background: #eff6ff;
    border-color: #93c5fd;
    color: #1d4ed8;
  }

  .file-name {
    font-weight: 500;
  }

  .file-ext {
    color: #94a3b8;
    font-size: 0.8rem;
  }
</style>
